import { ElectronApi } from '@/services/electron.api';
import { RemoteLibsService } from '@/services/remote-libs.service';
import { getCacheKey, imageCahcehIdb } from './utils/image.utls';
import { emptyDir, ensureDir, isDirectory } from '@/utils/fs/fs-extra.utils';

const imgFormatList: Record<string, string> = {
  truecolor_alpha: 'ARGB8888',
  truecolor: 'XRGB8888',
  alpha8: 'A8',
  indexed8: 'I8',
  rgb565: 'RGB565'
};

/**
 * 编译图片为lvgl需要的格式，编译的图片会放在temp目录下
 * @param data
 * @returns
 */
const _lvglImage = async (data: {
  fileOrDir: string;
  format: string;
  isRle: boolean;
}) => {
  const { fileOrDir, format, isRle = false } = data;

  const path = ElectronApi.path;
  const fs = ElectronApi.fs;
  if (!path || !fs) return;

  const service = new RemoteLibsService();
  const execPath = (await service.getLibFilename('LVGLImage')) ?? '';
  const _tempPath = await ElectronApi.getPath('temp');

  if (!path || !execPath || !fs || !_tempPath) return;
  const tmpPath = path.join(_tempPath, 'lvglImage');
  await ensureDir(_tempPath);
  await emptyDir(_tempPath);

  const fmt = imgFormatList[format];
  console.time('LVGLImage' + fileOrDir);
  await ElectronApi.execFile(execPath, [
    fileOrDir,
    '-o',
    tmpPath,
    '--cf',
    fmt,
    '--compress',
    isRle ? 'RLE' : 'NONE'
  ]);
  console.timeEnd('LVGLImage' + fileOrDir);

  const res: { filename: string; binBuffer: Buffer }[] = [];
  if (await isDirectory(fileOrDir)) {
    const files = (await fs.promises.readdir(fileOrDir)).filter((item) =>
      item.endsWith('.png')
    );
    for (const file of files) {
      const binPath = path.join(tmpPath, file.replace(/\.png$/, '.bin'));
      res.push({
        filename: path.join(fileOrDir, file),
        binBuffer: await fs.promises.readFile(binPath)
      });
    }
  } else {
    const binPath = path.join(
      tmpPath,
      path.basename(fileOrDir).replace(/\.png$/, '.bin')
    );
    res.push({
      filename: fileOrDir,
      binBuffer: await fs.promises.readFile(binPath)
    });
  }

  // 保存到缓存
  for (const item of res) {
    const { filename, binBuffer } = item;
    const cacheKey = await getCacheKey({
      imgPath: filename,
      format,
      is16bpp: isRle
    });
    if (cacheKey && binBuffer) {
      const ab = binBuffer.buffer as ArrayBuffer;
      await imageCahcehIdb?.putItem(cacheKey, ab);
    }
  }

  return res;
};

export const getThenCacheRiveDirBuffer = async (data: {
  dir: string;
  format: string;
  isRle: boolean;
}) => {
  const { dir, format, isRle = false } = data;

  // 首先进行lvgl处理
  await _lvglImage({ fileOrDir: dir, format, isRle });
};

const getThenCacheRiveImageBuffer = async (data: {
  imgPath: string;
  format: string;
  isRle: boolean;
}) => {
  const path = ElectronApi.path;
  const fs = ElectronApi.fs;
  if (!path || !fs) return;

  const { imgPath, format, isRle = false } = data;
  let cacheKey = '';
  let buf: Buffer | undefined = undefined;
  // 查询是否已存在缓存
  try {
    cacheKey = await getCacheKey({
      imgPath,
      format,
      is16bpp: isRle
    }).then((r) => r ?? '');

    const ab: ArrayBuffer = cacheKey
      ? await imageCahcehIdb.getItem(cacheKey)
      : undefined;
    if (ab) {
      buf = Buffer.from(ab);
    }
  } catch (error) {
    console.warn(error);

    buf = undefined;
  }

  if (!buf) {
    const res = await _lvglImage({ fileOrDir: imgPath, format, isRle });
    const bufNew = res?.[0]?.binBuffer;
    if (bufNew) buf = bufNew;
  }

  return buf;
};

export default async function (
  imgPath: string,
  imgFormat: string,
  isRle?: boolean
) {
  const buf = await getThenCacheRiveImageBuffer({
    imgPath,
    format: imgFormat,
    isRle: !!isRle
  });
  if (!buf) {
    console.warn(
      'getThenCacheRiveImageBuffer 返回空',
      imgPath,
      imgFormat,
      isRle
    );
  }
  return buf;
}
